import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../../../common';
import { FormsModule } from '@angular/forms';
import { CreateOrgVdcWizard } from './create-org-vdc.wizard';


import { EditVdcDialog } from './dialog/edit-vdc-component';
import { EditStoragePolicyDialog } from './dialog/edit-sp-component';

import { SddcPool } from './steps/sddc-pool.component';
import { DescVdc } from './steps/desc-vdc.component';
import { AllocationModel } from './steps/alloc-model.component';

import { ReadyToComplete } from './steps/ready-to-complete.component';
import { StorageProfileEdit } from './storage-profile/storage-profile-edit';
import { StorageProfileCreate } from './storage-profile/storage-profile-create';
import { StorageProfileEditComponent } from './storage-profile/storage-profile-edit.component';
import { StorageProfileCreateComponent } from './storage-profile/storage-profile-create.component';
import { SharedService } from './shared-service';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
    imports: [
        CommonModule,
        ClarityModule.forRoot(),
        FormsModule,
        VcaCommonModule,
        TranslateModule
    ],
    declarations: [
        CreateOrgVdcWizard,

        EditVdcDialog,
        EditStoragePolicyDialog,
        SddcPool,
        DescVdc,
        AllocationModel,
        ReadyToComplete,
        StorageProfileEdit,
        StorageProfileCreate,
        StorageProfileEditComponent,
        StorageProfileCreateComponent
    ],
    exports: [
        CreateOrgVdcWizard,

        EditVdcDialog,
        EditStoragePolicyDialog,
        SddcPool,
        DescVdc,
        AllocationModel,
        ReadyToComplete,
        StorageProfileEdit,
        StorageProfileCreate,
        StorageProfileEditComponent,
        StorageProfileCreateComponent
       ]
})
export  class OrgVdcWizardModule {
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/org-vdc.wizard.module.ts